import { ReactElement, ReactNode } from 'react';
import { useDispatch } from 'react-redux';

// Store
import { downloadProviderFile } from 'store/fileDownload/actions';
import { PARSAction } from 'core/models';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from 'store';

// Types
export interface IManualDownloadLinkProps {
  children: ReactNode;
  fileName: string;
  id: string;
}

export const ManualDownloadProviderFileLink = (props: IManualDownloadLinkProps): ReactElement => {
  const { fileName, id, children } = props;
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();

  const handleDownload = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
    event.preventDefault();
    dispatch(downloadProviderFile({ fileName, id }));
  };

  return (
    <a download onClick={handleDownload} href={fileName} role="button" style={{ display: 'inline-block' }}>
      {children}
    </a>
  );
};
